import { useEffect } from 'react';
import Hero from '../components/home/Hero';
import Metiers from '../components/home/Metiers';
import PourquoiNousChoisir from '../components/home/PourquoiNousChoisir';
import Chiffres from '../components/home/Chiffres';
import Projets from '../components/home/Projets';
import Temoignages from '../components/home/Temoignages';
import Partenaires from '../components/home/Partenaires';
import QuiSommesNous from '../components/home/QuiSommesNous';

export default function Home() {
    // Mise à jour du titre de la page
    useEffect(() => {
        document.title = "SOCABEG - Société d'Aménagement de Bâtiment et d'Etudes Générales";
    }, []);
    
    return (
        <div>
            <div><Hero /></div>
            <div className="pt-8">
                <div><QuiSommesNous /></div>
                <div><Metiers /></div>  
                <div><Chiffres /></div>
                <div><PourquoiNousChoisir /></div>
                <div><Projets /></div>
                <div><Temoignages /></div>
                <div><Partenaires /></div>
            </div>
        </div>
    );
}
